
import { Platform } from "react-native";
import { useAppSelector } from "../redux/hooks";
import { store } from "../redux/store";

const { isLandscape } = store.getState().common

export const appColors = {
    lightBackgroundColor: '#f5f5f5',
    primary: '#005374',
    lightPrimary: '#DBF5FF',
    tealPrimary: '#EAF6F8',
    borderColor: '#ddd',
    light: '#ffffff',
    dark: '#414141',
    lightFontColor: '#8f8f8f',
    lightYellow: "#ffedbd",
    // labelColor: '#86939e',
    labelColor: '#727272',
    lightDark: '#414141',
    lightGrey: 'lightgrey',
    disableTextColor: '#a0a0a0',
    green: '#51ad46',
    grey: 'grey',
    transparentBackground: '#00000080',
    iconColor: '#4b4a4a',
    icon: "#b7b7b7",
    secondary: '#ff8517',
    red: '#d72c0c',
    darkRed: '#de3a3b',

    transparent: 'transparent',
    stepperUnfinishedColor: '#aaaaaa',
    inActiveColor: '#cc2525',
    activeColor: '#02a302',
    bottomSheetIcon: '#808080',
    checkCircle: '#159326',
    searchbarBackground: '#F5F5F5',
    pendingColor: '#faad14',
    checkboxChecked: '#375866',
    warning: '#ffcc33',
    abandonedLinear: {
        green: '#3ab4a1',
        blue: '#2f95a0',
        darkBlue: '#1f6d9f'
    },
    touchableBackground: '#FF8517',
    meroongrey: '#757373',
    saturatedGreen: '#9ACD32',
    orange: '#ff6d33',
    whiteRed: '#f9f5f5',
    badgeBackground: '#ED3939',
    dropdownPlaceHolder: '#9ea8b1',
    rating: '#dba502',
    badgeColor: '#018100',
    badgeActive: '#c4ffc4',
    badgeInActive: '#ffd9d9',
    darkGreen: '#025402',
    railviewColor: '#E4E4E4',
    whiteGreen: '#C7F6B6',
    lightSaturatedGreen: '#00AB08',
    buttonColor: '#f1f1f1',
    dropdownBottomColor: '#899499',
    lightRed: '#faf7f7',
    nameTextForOrder: '#407eec',
    statusTextForOrder: '#459330',
    paymentTextForOrder: '#2f3bf4',
    lightDarkBlue: '#208fb8',
    mayGreen: '#459330',
    darkBlue: '#2f3bf4',
    readEnableSwitch: '#7fa9b9',
    readDisableSwitch: '#e9e9ea',
    customerStatus: {
        activeOrApprovedStatus: 'green',
        pendingStatus: '#ff8518',
        declinedStatus: 'red',
        wholesaleStatus: '#016f9b',
        typeWholesalecolor: 'purple'
    },
    mildBlack: '#4a4a4a',
    wildRed: '#ff696e',
    wildGreen: '#0ca85a',
    wildBlue: '#357994',
    persianGreen: '#00abab',
    wildPink: '#ad639e',
    digitalProduct: '#a80287',
    lighterGrey: "#D9D9D9",
    badgeLightColor: '#ffedbd',


    //For Sellscreen
    draggerIcon: '#94A3B8',
    coolGray: '#E2E8F0',
    tealGreen: '#10B981',
    green50: '#A7F3D0',
    lightTealGreen: '#ECFDF5',
    warmCream: '#FFF7ED',
    goldenOrange: '#F59E0B',
    blue50: "#EFF6FF",
    blue200: '#82A8F9',
    blue600: "#2563EB",
    red10: '#FEE2E2',
    red50: "#FEF2F2",
    red500: "#EF4444",
    disableGray: '#F3F4F6',
    disabledGray500: '#64748B',
    thickDark: '#0F172A',
    iceWhite: '#F8FAFC',
    softSlate: '#F1F5F9',

    modalBg100: 'rgba(15,23,42, 0.2)',
    modalBg300: 'rgba(0,0,0,0.5)',

    couponDis: '#3B82F6',
    additionalDis: '#10B981',
    addCharge: '#F59E0B',
    tip: '#EC4899',
}

export const appFonts = {
    medium: 'Montserrat-Medium',
    bold: 'Montserrat-SemiBold',
}

/**
 * Desktop type scale.
 *
 * The native scale is tuned for a phone or a tablet held at arm's length:
 * 17px body, 16px labels, 18px buttons. On a monitor at desk distance that
 * reads oversized and leaves the hierarchy flat - only 3px separate the page
 * title from body text. This scale keeps the page title where it is and
 * tightens everything under it, which both matches desktop convention and
 * restores the steps between title, section, body and label.
 *
 * Applied through Platform.OS, so Android and tablet keep the scale above
 * untouched. It is the single source for both `fontSize` and `useFontSize`,
 * which is what makes it reach the style factories in theme.ts as well as
 * the components that read theme?.mediumFontSize directly.
 *
 * zen-core-elements has its own copy of these numbers; the web build feeds
 * it the same scale through src/platform/design/zenConstants.web.ts.
 */
const webFontScale = {
    headerFontSize: 20, // page header - unchanged, it anchors the page
    largerFontSize: 16, // section title, button
    mediumFontSize: 15, // body text
    smallerFontSize: 14, // label, input
    smallFontSize: 13, // search placeholder, helper
    smallHeaderFontSize: 12,
    tinyFontSize: 13,
    errorFontSize: 12, // error, tooltip
    badgeFontSize: 10,
    iconSize: 18,
}

const isWeb = Platform.OS === "web"

export const fontSize = isWeb ? { ...webFontScale } : {
    headerFontSize: isLandscape ? 20 : 18, // pageheader
    largerFontSize: isLandscape ? 18 : 16,
    mediumFontSize: isLandscape ? 17 : 15, // button, normal text,input, form input placeholder
    smallerFontSize: isLandscape ? 16 : 14, // label
    smallFontSize: isLandscape ? 15 : 13, //  search placeholder
    smallHeaderFontSize: isLandscape ? 14 : 12,
    tinyFontSize: isLandscape ? 15 : 13,
    errorFontSize: isLandscape ? 13 : 12, // error, tooltip
    badgeFontSize: isLandscape ? 11 : 10,

    iconSize: isLandscape ? 20 : 18
}

export const useFontSize = (isLandscape: boolean) => {

    const scale = isWeb ? webFontScale : {
        headerFontSize: isLandscape ? 20 : 18,
        largerFontSize: isLandscape ? 18 : 16,
        mediumFontSize: isLandscape ? 17 : 15,
        smallerFontSize: isLandscape ? 16 : 14,
        smallFontSize: isLandscape ? 15 : 13,
        smallHeaderFontSize: isLandscape ? 14 : 12,
        tinyFontSize: isLandscape ? 15 : 13,
        errorFontSize: isLandscape ? 13 : 12,
        badgeFontSize: isLandscape ? 11 : 10,
        iconSize: isLandscape ? 20 : 18,
    }

    return {
        ...scale,

        //For sellscreen 
        miniFontSize: 12,
        miniLabel: 10,
        miniBadge: 9,
        bigFontSize: isWeb ? 20 : 22
    };
}